import { Box, Typography } from "@mui/material";
import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";

const AddressData = [
  {
    officeName: "Helpsoo Headquarters",
    description: "Reach out to our main office for any inquiries.",
    address:
      "Channasandra Hoskote, Samethanahalli, Bangalore Rural, Hosakote, Karnataka, India, 560067.",
    mail: "admin@helpsoo.com",
  },
  // {
  //   officeName: "Helpsoo West Coast Office",
  //   description: "Contact our team on the west coast.",
  //   address: "5678 Oak St, Los Angeles, CA",
  //   mail: "west@helpsoo.com",
  // },
  // {
  //   officeName: "Helpsoo East Coast Office",
  //   description: "Get in touch with our east coast representatives.",
  //   address: "9101 Pine St, New York, NY",
  //   mail: "east@helpsoo.com",
  // },
];
const Address = () => {
  return (
    <Box
      sx={{
        display: { xs: "block", md: "flex" },
        p: { lg: 5, xs: 1, md: 2 },
        px: { lg: 10, md: 5, xs: 1 },
      }}
    >
      {AddressData.map((item) => {
        return (
          <Box sx={{ px: 4, m: 2, my: { xs: 5 } }} key={item}>
            <Typography sx={{ fontWeight: "bold", fontSize: 25 }}>
              {item.officeName}
            </Typography>
            <Typography
              sx={{
                color: "#6b7c91",
                fontSize: 15,
                lineHeight: { md: 2.5 },
                py: 1,
              }}
            >
              {item.description}
            </Typography>
            <Box sx={{ display: "flex", py: 3 }}>
              <LocationOnIcon sx={{ color: "#347AEA" }} />
              <Typography sx={{ pl: 1 }}>{item.address}</Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              <MailIcon sx={{ color: "#347AEA" }} />
              <Typography sx={{ pl: 1 }}>{item.mail}</Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default Address;
